import { createFileRoute } from '@tanstack/react-router';

import { BookBrowse } from '@/module/Author/Book';

export const Route = createFileRoute('/_auth/author/_author/book/_book/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <BookBrowse />;
}
